import React from 'react';
import PropTypes from 'prop-types';
import MasterDataManagementPropertiesTable from './MasterDataManagementPropertiesTable';

const MasterDataManagementPropertyComponent = ({
  propertiesData,
  handleGridChanges,
  gridColumnState,
  handleGridColumnStateChange,
  refreshGridPropertyData,
  handleEditButtonClick,
  handleDeleteButtonClick,
  handleDismissErrorMessage,
}) => {
  return (
    <div>
      <div>
        <MasterDataManagementPropertiesTable
          propertiesData={propertiesData}
          handleGridChanges={handleGridChanges}
          gridColumnState={gridColumnState}
          handleGridColumnStateChange={handleGridColumnStateChange}
          handleEditButtonClick={handleEditButtonClick}
          handleDeleteButtonClick={handleDeleteButtonClick}
          handleDismissErrorMessage={handleDismissErrorMessage}
        />
      </div>
    </div>
  );
};

MasterDataManagementPropertyComponent.propTypes = {
  propertiesData: PropTypes.arrayOf(
    PropTypes.shape({
      propertyID: PropTypes.number,
      reitName: PropTypes.string,
      reitSuiteEntityID: PropTypes.string,
      gtpEntityID: PropTypes.string,
      clientEntityID: PropTypes.string,
      reitStatus: PropTypes.string,
      propertyName: PropTypes.string,
      propertyType: PropTypes.string,
      psqPropertyType: PropTypes.string,
      streetAddress: PropTypes.string,
      city: PropTypes.string,
      state: PropTypes.string,
      zipCode: PropTypes.string,
      rentableSqFt: PropTypes.number,
      purchasePrice: PropTypes.number,
      purchaseDate: PropTypes.string,
      endDate: PropTypes.string,
      propertyClass: PropTypes.string,
      tenantType: PropTypes.string,
      parking: PropTypes.string,
      managementCompany: PropTypes.string,
      managerName: PropTypes.string,
      managerEmail: PropTypes.string,
      managerPhone: PropTypes.string,
      accountantName: PropTypes.string,
      accountantEmail: PropTypes.string,
      accountantPhone: PropTypes.string,
    })
  ),
  selectedProperty: PropTypes.object,
  refreshGridPropertyData: PropTypes.object,
  handleEditButtonClick: PropTypes.func,
  handleDeleteButtonClick: PropTypes.func,
  handleConfirmButtonClick: PropTypes.func,
  handleDismissErrorMessage: PropTypes.func,
  handleGridColumnStateChange: PropTypes.func,
  handleGridChanges: PropTypes.func.isRequired,
  gridColumnState: PropTypes.object,
  gridCurrentState: PropTypes.object,
  handleSubmit: PropTypes.func,
  showDeletePropertyConfirmationModal: PropTypes.bool,
  toggleShowDeletePropertyConfirmationModal: PropTypes.func,
  toggleShowEditPropertyRowDataModal: PropTypes.func,
};

export default MasterDataManagementPropertyComponent;
